module.exports = __webpack_public_path__ + "img/New_Subscription_big_icon.b5a33ebb.svg";